import searchApi from './searchApi';

const searchModules = [
  { storeId: 'documents', moduleType: 'Document' },
  { storeId: 'news', moduleType: 'News' },
  { storeId: 'forms', moduleType: 'Form' },
  { storeId: 'gallery', moduleType: 'Gallery' },
  { storeId: 'gallery', moduleType: 'Gallery', specialAction: 'searchModuleInMemoryContainingSearchTerm_Image' },
  { storeId: 'videos', moduleType: 'Video' },
  { storeId: 'fahrdienst', moduleType: 'Fahrdienst' },
  { storeId: 'fahrplan', moduleType: 'fahrplan' },
  { storeId: 'fahrdienst452', moduleType: 'Fahrdienst452' },
  { storeId: 'meinDienst', moduleType: 'MeinDienst' },
  { storeId: 'messaging', moduleType: 'Messaging' },
  { storeId: 'wagenbuch', moduleType: 'Wagenbuch' },
  { storeId: 'unfalldesk', moduleType: 'Unfalldesk' },
  { storeId: 'weblinks', moduleType: 'Weblink' },
  { storeId: 'elearning', moduleType: 'ELearning' },
  { storeId: 'media', moduleType: 'Media' },
  { storeId: 'employee', moduleType: 'Employee' },
  // { storeId: 'welcome', moduleType: 'Welcome' },
];
// Module Id's of those modules which are indexed by elastic search and not in-memory-searched.
// However the Document module is not listed here, not because it is not "elastic searched", but the in-memory-search adds its results too (which is sometimes better oder faster)
const ELASTIC_SEARCH_MODULES = ['Fahrdienst452', 'Fahrdienst', 'Forms', 'Employees'];
const state = {
  isSearchVisible: false,
  search: '',
  searchResults: [],
  filterCriteria: [],
  titleOnly: true,
  isSearching: false,
  maxScore: undefined,
  searchTookMs: 0,
  selectedModules: [],
  virtualScrollKeepOption: 40, // decides the count of displayed search results
};

const getters = {};

const mutations = {
  setIsSearching: (state, isSearching) => (state.isSearching = isSearching),
  setIsSearchVisible: (state, isSearchVisible) => (state.isSearchVisible = isSearchVisible),
  resetSearchResults: (state) => {
    state.searchResults = [];
  },
  setMaxScore: (state, maxScore) => {
    state.maxScore = maxScore;
  },
  setSearchTookMs: (state, searchTookMs) => (state.searchTookMs = searchTookMs),
  setTitleOnly: (state, titleOnly) => (state.titleOnly = titleOnly),
  setSearchResults: (state, searchResults) => (state.searchResults = searchResults),
  setSelectedModules: (state, selectedModules) => (state.selectedModules = selectedModules),
  setStates(state, { searchTookMs, searchResults, isSearching }) {
    state.searchTookMs = searchTookMs;

    state.isSearching = isSearching;
    //state.maxScore = maxScore;
    // _maxScore = maxScore;
    //state.searchResults = searchResults;
    // Add searchResults to respect async nature of in-memory and elastic-search
    // searchResults && searchResults.forEach((r) => state.searchResults.push(r));
    // adjust scores to 0-1
    let titleSearchMaxScore = state.searchResults.reduce((previous, current) => (previous > current.score ? previous : current.score), 0);
    let elasticSearchMaxScore = searchResults.reduce((previous, current) => (previous > current.score ? previous : current.score), 0);
    state.maxScore = titleSearchMaxScore === 0 ? 1 : titleSearchMaxScore; //titleSearchMaxScore > elasticSearchMaxScore?titleSearchMaxScore: elasticSearchMaxScore;
    console.debug('Found titleSearchMaxScore', state.maxScore, 'elasticSearchMaxScore', elasticSearchMaxScore);
    searchResults.forEach((hit) => {
      console.debug('hit.score', hit.score);
      hit.score = (hit.score / elasticSearchMaxScore) * state.maxScore;
      console.debug('new hit.score', hit.score);
    });
    state.searchResults = state.searchResults.concat(searchResults).sort((a, b) => (a.score > b.score ? -1 : 1));
    console.debug('add fulltext search results. Total results', state.searchResults.length);
  },
  setFilterCriteria(state, { filterCriteria }) {
    state.filterCriteria = filterCriteria ? filterCriteria.toLowerCase().split(' ') : [];
  },
  /**
   * Used to add in memory module search results
   * @param {*} state
   * @param {*} param1
   */
  addModuleSearchResults(state, { results }) {
    //result && result.forEach((r) => state.searchResults.push(r));
    let searchResultsConcatenated = state.searchResults;
    results.forEach((result) => {
      if (result) searchResultsConcatenated = searchResultsConcatenated.concat(result);
    });
    let titleSearchMaxScore = searchResultsConcatenated.reduce((previous, current) => (previous > current.score ? previous : current.score), 0);
    state.maxScore = titleSearchMaxScore;
    state.searchResults = searchResultsConcatenated
      .filter((i) => !!i)
      .map((i) => {
        return { ...i, titleSearch: true };
      })
      .sort((a, b) => (a.score > b.score ? -1 : 1));
    console.debug(`add in-memory search results of ${results.length} modules, total searchResults=${state.searchResults.length}`);
  },

  setSearch(state, search) {
    try {
      if (state.search !== search.trim()) {
        state.search = search.trim();
      }
    } catch (err) {
      state.search.search;
    }
  },
};

const actions = {
  /**
   * This action is performed to search all modules with title search and elastic search.
   * params {object} payload  { query, maxItems, maxPagesPerHit, maxHighlightsPerPage, forceSearch = false, moduleInstances, titleOnly = false, fuzzy = false }
   */
  async searchAllModules({ commit, dispatch, state, rootGetters, rootState }, payload) {
    const fulltextSearchEnabled = rootState.configs.features.fulltextSearchEnabled;
    //const fulltextSearchEnabled = false;
    const isConnected = rootState.isConnected;
    const { search, forceSearch, limit, titleOnly } = payload;

    console.debug('perform search on selected modules', state.selectedModules);
    commit('setFilterCriteria', { filterCriteria: search });
    const filterCriteriaCount = state.filterCriteria.length;
    if (filterCriteriaCount === 0 || state.filterCriteria[0].length === 0) {
      state.searchResults = [];
      return;
    }
    state.searchResults = [];
    if (!search || search.length < 3) return;

    let performFulltextSearch = fulltextSearchEnabled && isConnected && (!state.isSearching || forceSearch);
    let performInMemorySearchOnly = (fulltextSearchEnabled && !isConnected) || (!fulltextSearchEnabled && (!state.isSearching || forceSearch));

    // if (!performFulltextSearch && performInMemorySearchOnly) {
    //   commit('setMaxScore', 2);
    // }

    if (performFulltextSearch && !performInMemorySearchOnly) {
      commit('setIsSearching', true);
      console.debug('PERFORM elastic search query');
      searchApi
        // .performSimpleSearch({ searchWords: query, maxItems, maxPagesPerHit, maxHighlightsPerPage, moduleInstances, titleOnly, fuzzy })
        .performSimpleSearch(payload)
        .then((response) => {
          //TODO: add all modules which can be searched with elastic search
          let moduleItemsByModuleTypeAndId = {
            document: rootState.documents.documentsById,
            news: rootState.news.newsById,
            news_attachements: rootState.news.mediasById,
            videos: rootState.videos.videosById,
            gallery: rootState.gallery.galleriesById,
            fahrdienst452: rootState.fahrdienst452.fahrdienst452FileById,
            fahrdienst: rootState.fahrdienst.filesById,
            fahrplan: rootState.fahrplan.fahrplanFilesById,
            media: rootState.media.containersByIdForSearch,
          };

          let { throwAwayCount, elasticHits } = postProcessElasticSearchResult(response, moduleItemsByModuleTypeAndId);
          if (throwAwayCount > 0)
            console.debug(
              'postProcessElasticSearchResult has ignorder some hits. throwawayCount',
              throwAwayCount,
              'response.hits.total.value ',
              response.hits.total.value
            );

          commit('setStates', {
            maxScore: response.hits.max_score,
            totalHits: response.hits.total.value - throwAwayCount,
            searchTookMs: response.took,
            searchResults: elasticHits,
            isSearching: false,
          });
        })
        .catch((err) => {
          console.warn('Failed to perform elastic search query', err);
          commit('setIsSearching', false);
        });
    }
    // Module in-memory searches
    const options = { titleOnly, modules: {} };

    let modulesToSearch =
      state.selectedModules.length === 0
        ? searchModules
        : searchModules.filter((m) => {
            let acceptedModule = state.selectedModules.find((selectedModule) => m.moduleType === selectedModule.value.module);
            if (acceptedModule) {
              options.modules[`${m.storeId}${acceptedModule.value.instance ? '_' + acceptedModule.value.instance : ''}`] = {
                ...acceptedModule.value,
                moduleId: m.storeId,
              };
            }
            return !!acceptedModule;
          });
    if (performInMemorySearchOnly) {
      console.debug('PERFORM LOCAL IN-MEMORY SEARCH (no elastic search at all)', modulesToSearch);
    } else {
      modulesToSearch = modulesToSearch.filter((m) => !ELASTIC_SEARCH_MODULES.includes(m.moduleType));
      console.debug('PERFORM LOCAL IN-MEMORY SEARCH for modules not indexed by elastic search', modulesToSearch);
    }

    let filterCriteriaNoWildcards = state.filterCriteria.map((fc) => fc.replaceAll('*', ''));
    // Delegate search to modules
    let promises = [];
    for (let i = 0; i < modulesToSearch.length; i++) {
      let m = modulesToSearch[i];
      // perform in memory search for all modules implementing the search
      promises.push(
        dispatch(
          `${m.storeId}/${m.specialAction ? m.specialAction : 'searchModuleInMemoryContainingSearchTerm'}`,
          { filterCriteria: filterCriteriaNoWildcards, options },
          { root: true }
        )
      );
    }
    Promise.all(promises)
      .then((results) => {
        commit('addModuleSearchResults', { results });
        console.debug('ALL RESULTS ASSEMBLED for search ' + filterCriteriaNoWildcards);
        // all searches have been completed. The isSearching flag can be reset to allow new searches
        commit('setIsSearching', false);
      })
      .catch((err) => {
        console.warn('Failed to accumulate in-memory-search-results', err);
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

/**
 * Perform a logical AND search on the provided items (array),
 * looking within the search attributes (titleSearchAttr and contentSearchAttr) field for all words within the searchCriteriaArray
 * @param {*} param0
 */
export function performInMemorySearch({ moduleId, items, titleSearchAttr, contentSearchAttr, searchCriteriaArray, options = {} }) {
  if (!items || !items.filter) return null;
  let lowerCasedSearchCriteria = searchCriteriaArray.map((sc) => sc.toLowerCase()).filter((i) => i !== 'and');
  const filterCriteriaCount = lowerCasedSearchCriteria.length;
  console.debug(`performInMemorySearch `, moduleId, 'lowerCasedSearchCriteria', lowerCasedSearchCriteria, 'options', options);

  const results = items
    .filter((item) => {
      // Remove any items not correctly mapped (it won't be possible to display them)
      if (!item._moduleTitle) {
        return false;
      }
      // if modules are selected, items of other instances need to be excluded
      if (options.modules && Object.keys(options.modules).length > 0) {
        // module selection
        if (item.instance) {
          if (!options.modules[`${moduleId}_${item.instance}`]) {
            //console.debug(`in-memory-search excludes item id=${item.id} of module ${moduleId} with instance=${item.instance} because this instance is not selected`);
            return false;
          }
        }
      }
      let titleHits = [];
      if (titleSearchAttr && item[titleSearchAttr]) {
        let lowerCaseText = item[titleSearchAttr].toLowerCase();

        titleHits = lowerCasedSearchCriteria.filter((fc) => lowerCaseText.indexOf(fc) >= 0);
      }
      // There is a hit, if all search terms are found
      let hasTitleHit = titleHits.length === filterCriteriaCount;

      if (contentSearchAttr && !options.titleOnly) {
        let hasContentHit = false;
        if (!item[contentSearchAttr]) {
          console.debug(`item of type ${moduleId} does not contain a ${contentSearchAttr}`);
        } else {
          let lowerCaseContent = item[contentSearchAttr].toLowerCase();
          hasContentHit = lowerCasedSearchCriteria.filter((fc) => lowerCaseContent.indexOf(fc) >= 0).length === filterCriteriaCount;
        }
        return hasTitleHit || hasContentHit;
      }

      return hasTitleHit;
    })
    .map((item) => {
      // console.debug('item found', item[titleSearchAttr], item[contentSearchAttr]);
      let hitCount = { count: 0, score: 0 };
      //-------- title hits
      let title;
      if (titleSearchAttr && item[titleSearchAttr]) {
        title = item[titleSearchAttr];
        title = highlightHitsIgnoringCase(lowerCasedSearchCriteria, title, hitCount);
      }
      //-------- content hits
      let content = contentSearchAttr ? item[contentSearchAttr] : '';
      content = highlightHitsIgnoringCase(lowerCasedSearchCriteria, content, hitCount);

      let result = {
        id: item.id,
        location: item._displayLocation,
        title: title ? item[titleSearchAttr] : item._moduleTitle + ' ' + item.id,
        //content: clippedContent,
        moduleTitle: item._moduleTitle,
        path: item._path,
        highlight: {},
        score: hitCount ? hitCount.count + hitCount.score : 0.5,
      };
      if (title) {
        result.highlight.title = title;
      }
      if (content) {
        result.highlight.pages = [{ page: 0, highlights: [content] }];
      }
      return result;
    });
  return results;
}

/**
 * Highlights all hits for search terms in lowerCasedSearchCriteria
 * @param {*} lowerCasedSearchCriteria
 * @param {*} str
 * @returns
 */
export function highlightHitsIgnoringCase(lowerCasedSearchCriteria, str, hitCount) {
  if (!str) return str;
  let lowerCasedStr = str.toLowerCase();
  let realCasedStr = str;
  lowerCasedSearchCriteria.forEach((searchTerm) => {
    let start = 0;
    do {
      start = lowerCasedStr.indexOf(searchTerm, start);
      if (start >= 0) {
        if (hitCount) hitCount.count++;
        if (start === 0 && hitCount) hitCount.score++; // more weight if hit is at the beginning of a word
        let end = start + searchTerm.length;
        let realCased = realCasedStr.substring(start, end);
        lowerCasedStr = lowerCasedStr.substring(0, start) + `<em>${realCased}</em>` + lowerCasedStr.substring(end);
        realCasedStr = realCasedStr.substring(0, start) + `<em>${realCased}</em>` + realCasedStr.substring(end);
        start += 9;
      }
    } while (start >= 0 && start < lowerCasedStr.length);
  });
  return realCasedStr;
}

/**
 * Map and filter search results. Only items which have a corresponding cached meta data record, are accepted.
 * This means all unwanted or especially restricted items are evicted.
 * @param {*} response
 * @param {*} moduleItemsByModuleTypeAndId
 * @returns
 */
export function postProcessElasticSearchResult(response, moduleItemsByModuleTypeAndId) {
  let elasticHits = [];
  let throwAwayCount = 0;
  response.hits.hits.forEach((hit) => {
    let { id, instance, module, page, title, titleInfo } = hit._source;

    if (moduleItemsByModuleTypeAndId[module]) {
      let item = moduleItemsByModuleTypeAndId[module][id];
      if (item && item._path) {
        let moduleTitle = item._moduleTitle;
        let result = {
          id,
          location: item._displayLocation,
          title: title,
          score: hit._score,
          moduleTitle,
          path: item._path,
        };
        if (!isNaN(page)) {
          result.page = Number(page);
        }
        result.highlight = hit.highlight;
        elasticHits.push(result);
      } else {
        throwAwayCount++;
        console.debug('Throw away one hit since no item for module ', module, ' and id', id);
      }
    } else {
      throwAwayCount++;
      console.debug('Throw away one hit since no items for module ', module);
    }
  });
  return { throwAwayCount, elasticHits };
}
